import { LabelledElement } from "../Fields";
import { SearchByMultipleRetailer } from "pages/Filters/Components/SearchByMultipleRetailer";
import { getRetailerAutocompleteApi } from "api";
import useAdBlockStore from "store/AdBlockStore";

export const FsiRetailerSelector = ({ fsiRetailerIds }) => {
  const updateMetaDataField = useAdBlockStore((state) => state.updateMetaDataField);

  const handleSelectFsiRetailers = (values = []) => {
    const retailerIds = values
      .map((item) => item?.value)
      .filter(Boolean)
      .join(",");

    updateMetaDataField("fsi_retailer_i", retailerIds);
  };

  return (
    <div className="mt-5" >
      <LabelledElement label="Select Retailers for FSI" >
        <SearchByMultipleRetailer
          fsiRetailerIds={fsiRetailerIds}
          func={getRetailerAutocompleteApi}
          containerStyle={{ padding: '0px' }}
          styles={{ width: '100%', padding: '0px' }}
          placeholder="Select Retailers for FSI"
          onSelect={handleSelectFsiRetailers}
        />
      </LabelledElement>
    </div>
  );
};